export default "__VITE_ASSET__8Nv1isdO__"